let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2Ol9B")).then(() => parcelRequire('74uqO'));